import React from 'react';
import uniqueId from 'lodash/uniqueId';
import { withTooltip } from '@eb/eds-tooltip';
import { Icon } from '@eb/eds-icon';
import { EyeOff } from '@eb/eds-iconography';
import { getSalesStatusVisibilityInfo } from './utils';

import './EventVisibilityIcon';

const IconWithTooltip = withTooltip(Icon);

export default function EventVisibilityIcon({ statusInfo }) {
    const { label, visibility } = getSalesStatusVisibilityInfo(statusInfo);
    let visibilityIcon = null;

    if (visibility) {
        visibilityIcon = (
            <div className="event-status" data-spec="event-status-icon">
                <IconWithTooltip
                    type={<EyeOff />}
                    tooltipArrowLocation="bottom"
                    tooltipText={visibility}
                    tooltipId={uniqueId('tooltip-')}
                />
                <span className="eds-text-color--grey-900 eds-l-pad-left-1">
                    {label}
                </span>
            </div>
        );
    }

    return visibilityIcon;
}
